$(function () {
  let section = $('#cuenta-datos-personales')
  if (section.get(0) == null) {
    return
  }

  let vueApp = new Vue({
    el: section.get(0),
    data: {
      cliente: {},
    },
    mounted() {
      this.cliente = Object.assign({}, clienteJson)
      vueApp = this
      this.validar()
    },
    methods: {
      validar(){
        $('#formGeneral').validarForm((form) => {
          vueApp.guardar(form)
        })
      },
      guardar(form){
        $("#btnGeneral").loader("show")
        var formData = new FormData(form)
        if(this.cliente.file != null){
          formData.append("imagen", this.cliente.file)
        }
        axios
          .post("/mi-perfil/actualizar", formData)
          .then((respuesta) => {
            $("#btnGeneral").loader("hide")
            if (respuesta.data.error) {
              swal({
                icon: "info",
                title: respuesta.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            $('#formGeneral')[0].reset();
            clienteJson = respuesta.data.cliente
            vueApp.cliente = Object.assign({}, clienteJson)
            swal({
              icon: "success",
              title: "Información actualizada correctamente",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            $("#btnGeneral").loader("hide")
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      },
      pickImagenPerfil(e){
        if(e.srcElement.files.length > 0){
          this.cliente.file = e.srcElement.files[0]
          this.cliente.url_file = URL.createObjectURL(e.srcElement.files[0])
        }
        e.srcElement.value = "";
        this.$forceUpdate()
      },
    }
  });
});
